// extracted by mini-css-extract-plugin
export default {"highlight":"HighlightedText_highlight__Gcg7-"};